import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useSearchParams } from 'react-router';
import { Params } from '@/utils/types';
import { useId } from 'react';
import { DeploymentTypeEnum, deploymentTypeLabels, SWAP_REASONS, SWAP_REASONS_LABELS } from '../measurement-group/field-report/types';

type FieldReportsFiltersProps = {
	handleSearchChange: (search: string) => void;
	handleDeploymentTypeChange: (deploymentType: DeploymentTypeEnum | 'All') => void;
	handleSwapReasonChange: (swapReason: SWAP_REASONS | 'All') => void;
	handleHasExternalAntennasChange: (hasExternalAntennas: 'true' | 'false' | 'N/A') => void;
};

const deploymentTypeOptions = [
	{ key: 'All', value: 'All' },
	...Object.entries(deploymentTypeLabels).map(([key, value]) => ({ key, value }))
];

const swapReasonOptions = [
	{ key: 'All', value: 'All' },
	...Object.entries(SWAP_REASONS_LABELS).map(([key, value]) => ({ key, value }))
];

const hasExternalAntennasOptions = [
	{ key: 'N/A', value: 'N/A' },
	{ key: 'true', value: 'Yes' },
	{ key: 'false', value: 'No' }
];

export const FieldReportsListFilters = (props: FieldReportsFiltersProps) => {
	const { handleSearchChange, handleDeploymentTypeChange, handleSwapReasonChange, handleHasExternalAntennasChange } = props;
	const [searchParams] = useSearchParams();
	const searchInputUuid = useId();
	return (
		<div className="flex flex-col gap-1 lg:gap-5 lg:flex-row">
			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor={searchInputUuid} className="text-sm">
					Search
				</Label>
				<Input
					type="text"
					id={searchInputUuid}
					defaultValue={searchParams.get(Params.search) || ''}
					onChange={event => handleSearchChange(event.target.value)}
					className="w-full"
					placeholder="Search"
					aria-label="Search"
				/>
			</div>

			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="deploymentType" className="text-sm">
					Deployment type
				</Label>
				<Select value={searchParams.get(Params.deploymentType) || 'All'} onValueChange={handleDeploymentTypeChange}>
					<SelectTrigger className="w-full" aria-label="Deployment type" id="deploymentType">
						<SelectValue placeholder="Deployment type" />
					</SelectTrigger>
					<SelectContent>
						{deploymentTypeOptions.map(option => (
							<SelectItem key={option.key} value={option.key}>
								{option.value}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="swapReason" className="text-sm">
					Swap Reason
				</Label>
				<Select value={searchParams.get(Params.swapReason) || 'All'} onValueChange={handleSwapReasonChange}>
					<SelectTrigger className="w-full" aria-label="Swap Reason" id="swapReason">
						<SelectValue placeholder="Swap Reason" />
					</SelectTrigger>
					<SelectContent>
						{swapReasonOptions.map(option => (
							<SelectItem key={option.key} value={option.key}>
								{option.value}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>

			<div className="flex flex-col gap-2 min-w-2xs">
				<Label htmlFor="hasExternalAntennas" className="text-sm">
					Has External Antennas
				</Label>
				<Select value={searchParams.get(Params.hasExternalAntennas) || 'N/A'} onValueChange={handleHasExternalAntennasChange}>
					<SelectTrigger className="w-full" aria-label="Has External Antennas" id="hasExternalAntennas">
						<SelectValue placeholder="Has External Antennas" />
					</SelectTrigger>
					<SelectContent>
						{hasExternalAntennasOptions.map(option => (
							<SelectItem key={option.key} value={option.key}>
								{option.value}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		</div>
	);
};
